import { useCallback, useState } from "react";
import api from "../utils/api"; // 🔥 değişti

export function useBackwardPrograms(channelId) {
  const [backwardPrograms, setBackwardPrograms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchBackward = useCallback(
    async ({ programId, weekdayInt, programStart, backwardCount }) => {
      if (!channelId || !programId) return;

      setLoading(true);
      setError("");

      try {
        const res = await api.get("/api/EpgLogs", { // 🔥 axios instance
          params: {
            channel_id: channelId,
            program_id: programId,
            weekday_int: weekdayInt,
            start_date: programStart,
            program_backward: backwardCount,
          },
        });

        setBackwardPrograms(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        console.error("Backward program fetch error:", e);
        setError("Failed to load backward programs");
        setBackwardPrograms([]);
      } finally {
        setLoading(false);
      }
    },
    [channelId]
  );

  return { backwardPrograms, fetchBackward, loading, error };
}